import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FaChevronDown } from "react-icons/fa";

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [productDropdownOpen, setProductDropdownOpen] = useState(false);

  const handleNavClick = () => {
    setMobileMenuOpen(false);
    setProductDropdownOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`sticky top-0 left-0 right-0 bg-white z-50 transition-all duration-300 ${
        scrolled ? "shadow-md py-4" : "py-4"
      }`}
    >
      <div className="container mx-auto px-4">
        <nav className="flex justify-between items-center">
          {/* Logo */}
          <Link
            to="/"
            className="text-2xl font-bold text-gray-800 flex items-center"
          >
            <span className="text-primary">SPC</span> Edge
          </Link>

          {/* Hamburger Button (visible only on mobile) */}
          <button
            className="md:hidden text-2xl bg-transparent border-none cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? "×" : "☰"}
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Product Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setProductDropdownOpen(true)}
              onMouseLeave={() => setProductDropdownOpen(false)}
            >
              <button className="text-gray-700 hover:text-primary font-medium flex items-center">
                Product <FaChevronDown className="ml-1 text-xs" />
              </button>
              {productDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-md py-2 min-w-[160px] z-50">
                  <HashLink
                    to="/#features"
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary"
                  >
                    Features
                  </HashLink>
                  <HashLink
                    to="/#interfaces"
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-primary"
                  >
                    Interfaces
                  </HashLink>
                </div>
              )}
            </div>
            <Link
              to="/roi-calculator"
              className="text-gray-700 hover:text-primary font-medium"
            >
              ROI Calculator
            </Link>
            <HashLink
              to="/#pricing"
              className="text-gray-700 hover:text-primary font-medium"
            >
              Pricing
            </HashLink>
            <Link
              to="/education"
              className="text-gray-700 hover:text-primary font-medium"
            >
              Education
            </Link>
            <HashLink
              to="/#contact"
              className="text-gray-700 hover:text-primary font-medium"
            >
              Contact Us
            </HashLink>
            <HashLink to="/#contact" className="btn btn-primary ml-4">
              Request Demo
            </HashLink>
          </div>
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div
            className={`md:hidden absolute ${
              scrolled ? "py-2" : "py-4"
            } left-0 w-full bg-white shadow-md py-4 z-50 animate-fadeIn`}
          >
            <div className="flex flex-col items-center space-y-4">
              <HashLink
                to="/#features"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                Features
              </HashLink>
              <HashLink
                to="/#interfaces"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                Interfaces
              </HashLink>
              <Link
                to="/roi-calculator"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                ROI Calculator
              </Link>
              <HashLink
                to="/#pricing"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                Pricing
              </HashLink>
              <Link
                to="/education"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                Education
              </Link>
              <HashLink
                to="/#contact"
                className="text-gray-700 hover:text-primary font-medium w-full text-center py-2"
                onClick={handleNavClick}
              >
                Contact Us
              </HashLink>
              <HashLink
                to="/#contact"
                className="btn btn-primary w-4/5 mx-auto mt-2"
                onClick={handleNavClick}
              >
                Request Demo
              </HashLink>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
